<template>
  <BasicLayout>
    <template #wrapper>
      <el-card :bordered="false" :body-style="{padding: '0'}">

        <div class="salesCard">
          <el-form :inline="true">
            <el-form-item label="类型">
              <el-select v-model="queryParams1.type" placeholder="请选择">
                <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
              <el-date-picker
                v-model="queryParams1.startDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker
                v-model="queryParams1.endDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button :loadin="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery(0)">查询</el-button>
              <!--              <el-button v-if="isExport" type="primary" icon="el-icon-download" size="mini" @click="handleQuery(1)">导出</el-button>-->
            </el-form-item>
          </el-form>
          <div ref="chartContainer" style="width: 100%; height: 400px;" />
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import echarts from 'echarts'
import { getLoginEventRateStat } from '@/api/statistics/user_remain'
import { dateStrTodate, getLastDates } from '@/utils'
export default {
  name: 'LoginEventStat',
  props: {
    isExport: {
      Type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      chartData: {},
      queryParams1: {
        startDate: '',
        endDate: '',
        type: 1,
        level: 0
      },
      types: [{ label: '登录成功', value: 1 }, { label: '注册成功', value: 2 }]
    }
  },
  created() {
    this.queryParams1.startDate = getLastDates(7)
    this.queryParams1.endDate = getLastDates(1)
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery(isExport = 0) {
      if (!this.queryParams1.startDate) {
        this.msgError('开始日期不能为空')
        return
      }

      if (!this.queryParams1.endDate) {
        this.msgError('结束日期不能为空')
        return
      }
      this.initChart(isExport)
    },
    initChart(isExport = 0) {
      const chart = echarts.init(this.$refs.chartContainer)
      chart.showLoading()
      this.loading = true
      const option = {
        // color: ['#00BFFF', '#FF69B4', '#FF7F50', '#BA55D3', '#FFA500', '#7B68EE'],
        title: {
          text: '登录成功率统计',
          subtext: '登录成功人数/登录人数*100',
          subtextStyle: {
            color: '#000',
            fontSize: 12
          }
        },
        // graphic: [{
        //   type: 'text',
        //   left: 'center',
        //   top: 'middle',
        //   style: {
        //     text: '这是图表的说明文字',
        //     font: 'bold 20px Arial',
        //     fill: '#333'
        //   }
        // }],
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
      chart.setOption(option)
      setTimeout(() => {
        // this.queryParams1.level = 0
        // if (isExport) {
        // this.queryParams1.level = 1
        // }
        getLoginEventRateStat(this.queryParams1).then(res => {
          this.loading = false
          chart.hideLoading()
          if (res.code === 200) {
            // if (this.queryParams1.level === 1) {
            //   window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
            // }
            let defaultTitle = '登录成功率统计'
            let defaultSubTitle = '登录成功人数/登录人数*100'
            if (this.queryParams1.type === 2) {
              defaultTitle = '注册成功率统计'
              defaultSubTitle = '注册成功人数/注册人数*100'
            }
            option.title.text = defaultTitle
            option.title.subtext = defaultSubTitle
            if (res.data.length < 1) {
              return
            }
            const dateArr = {}
            const date = []
            const data = {}
            const legend = []
            const types = { GUEST: '游客', APPLE: '苹果', GOOGLE: '谷歌', FACEBOOK: 'FB' }
            res.data.data.forEach(item => {
              const _date = dateStrTodate(item.date)
              if (dateArr[_date] === undefined) {
                dateArr[_date] = 1
                date.push(_date)
              }

              if (data[item.loginType] === undefined) {
                data[item.loginType] = []
              }
              if (this.queryParams1.type === 2) {
                data[item.loginType].push(item.success_total_rate)
              } else {
                data[item.loginType].push(item.success_rate)
              }
            })
            for (const i in data) {
              legend.push(types[i])
              const temp = {
                name: types[i],
                data: data[i],
                type: 'line',
                smooth: true,
                label: {
                  show: true,
                  position: 'top', // 标签显示在折线图顶部
                  formatter: '{c}' // 显示数值
                }
              }
              option.series.push(temp)
            }
            option.legend.data = legend
            option.xAxis.data = date
            chart.setOption(option)
          } else {
            this.msgError(res.msg)
          }
        })
      }, 800)
    }
  }
}
</script>

  <style scoped />
